module.exports = __webpack_public_path__ + "img/download.c3b958a7.svg";